<nav class="py-1 bg-nz-primary navbar navbar-dark navbar-expand-md text-white shadow z-1" data-bs-theme="dark">
  <div class="container-lg">
    <div class="navbar-brand">
      <a aria-label="Начало"
         class="p-0 btn text-center border-0 d-flex justify-content-center align-items-center fw-medium fs-3"
         (click)="isCollapsed = true"
         [routerLink]="appRoutes.home">
        <nz-logo height="50" mode="monochromatic-light"/>
      </a>
    </div>
    <div class="position-relative">
      <button
        type="button"
        class="navbar-toggler"
        aria-label="Превключване на навигацията"
        (click)="collapse.toggle()"
        [attr.aria-expanded]="!isCollapsed">
        <span class="navbar-toggler-icon"></span>
      </button>
      @if (!!newMessageCount || !!newNotificationCount) {
        <div
          class="d-inline d-md-none notification-badge badge rounded-pill bg-danger position-absolute translate-middle">
          {{ newMessageCount + newNotificationCount }}
        </div>
      }
    </div>
    <div
      #collapse="ngbCollapse"
      [(ngbCollapse)]="isCollapsed"
      class="navbar-collapse justify-content-end">
      <hr/>
      <ul class="navbar-nav gap-2 gap-md-3 mb-2 mb-md-0">
        <li class="nav-item">
          <a aria-label="Начало"
             class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
             (click)="isCollapsed = true"
             [routerLink]="appRoutes.home">
            <i class="fa fa-home " aria-hidden="true"></i>
            <span>Начало</span>
          </a>
        </li>
        @if (loggedIn) {
          <li class="nav-item">
            <a aria-label="Нова обява"
               class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
               (click)="isCollapsed = true"
               [routerLink]="[appRoutes.root, appRoutes.adCrate]">
              <i class="fa fa-plus" aria-hidden="true"></i>
              <span>Нова обява</span>
            </a>
          </li>
        }
        <li class="nav-item">
          <a aria-label="Обяви"
             class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
             (click)="isCollapsed = true"
             [routerLink]="[appRoutes.root, appRoutes.adList]">
            <i class="fa fa-list" aria-hidden="true"></i>
            <span>Обяви</span>
          </a>
        </li>
        @if (loggedIn) {
          <li class="nav-item">
            <a aria-label="Профил"
               class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
               (click)="isCollapsed = true"
               [routerLink]="[appRoutes.root, appRoutes.profile, userId]">
              <i class="fa fa-user" aria-hidden="true"></i>
              <div class="position-relative">
                <span>Профил</span>
                @if (!!newMessageCount || !!newNotificationCount) {
                  <div
                    class="d-none d-md-inline notification-badge badge rounded-pill bg-danger position-absolute translate-middle">
                    {{ newMessageCount + newNotificationCount }}
                  </div>
                }
              </div>
            </a>
          </li>
          <li class="nav-item d-md-none">
            <a aria-label="Съобщения"
               class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
               (click)="isCollapsed = true"
               [queryParams]="{menuId: 2}"
               [routerLink]="[appRoutes.root, appRoutes.profile, userId]">
              <i class="fa fa-comment" aria-hidden="true"></i>
              <span>
                Съобщения
                @if (!!newMessageCount) {
                  <div class="badge rounded-pill bg-danger">{{ newMessageCount }}</div>
                }
              </span>
            </a>
          </li>
          <li class="nav-item d-md-none">
            <a aria-label="Известия"
               class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
               (click)="isCollapsed = true"
               [queryParams]="{menuId: 3}"
               [routerLink]="[appRoutes.root, appRoutes.profile, userId]">
              <i class="fa fa-bell" aria-hidden="true"></i>
              <span>
                Известия
                @if (!!newNotificationCount) {
                  <div class="badge rounded-pill bg-danger">{{ newNotificationCount }}</div>
                }
              </span>
            </a>
          </li>
        }
        <hr class="my-2 d-md-none">
        <li class="nav-item d-md-none">
          <a aria-label="Контакт с нас"
             class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
             (click)="isCollapsed = true"
             [routerLink]="[appRoutes.root, appRoutes.helpInformation]">
            <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
            <span>Помощен център</span>
          </a>
        </li>
        <li class="nav-item d-md-none">
          <a aria-label="Контакт с нас"
             class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
             (click)="isCollapsed = true"
             [routerLink]="[appRoutes.root, appRoutes.contactUs]">
            <i class="fa fa-envelope" aria-hidden="true"></i>
            <span>Контакт с нас</span>
          </a>
        </li>
        <li class="nav-item d-md-none">
          <a aria-label="Общи условия"
             class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
             (click)="isCollapsed = true"
             [routerLink]="[appRoutes.root, appRoutes.termsConditions]">
            <i class="fa fa-file-alt" aria-hidden="true"></i>
            <span>Общи условия</span>
          </a>
        </li>
        <li class="nav-item d-md-none">
          <a aria-label="Защита на лични данни"
             class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
             (click)="isCollapsed = true"
             [routerLink]="[appRoutes.root, appRoutes.privacyPolicy]">
            <i class="fa fa-user-shield" aria-hidden="true"></i>
            <span>Защита на лични данни</span>
          </a>
        </li>
        <hr class="my-2 d-md-none">
        @if (loggedIn) {
          <li class="d-md-none nav-item">
            <a aria-label="Изход"
               class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
               (click)="isCollapsed = true"
               [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.login]">
              <i class="fa fa-sign-out" aria-hidden="true"></i>
              <span>Изход</span>
            </a>
          </li>
        } @else {
          <li class="nav-item">
            <a aria-label="Регистрация"
               class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
               (click)="isCollapsed = true"
               [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.registration]">
              <i class="fa-solid fa-user-plus" aria-hidden="true"></i>
              <span>Регистрация</span>
            </a>
          </li>
          <li class="nav-item">
            <a aria-label="Вход"
               class="btn btn-link navbar-button w-100 d-flex align-items-center gap-2 p-1"
               (click)="isCollapsed = true"
               [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.login]">
              <i class="fa fa-sign-in" aria-hidden="true"></i>
              <span>Вход</span>
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
</nav>
